import parse from "html-react-parser"
import { formatDate } from '../utilities/utilities';

export default function Intro( props ) {
	const c = props.cruise
	return <>
	    <h1>{ c.title }</h1>
	    <p>{ parse( c.description || '' ) }</p>
	    <p>{ formatDate( c.first_day ) } - { formatDate( c.last_day ) }</p>
	</>
}
